import { redirectToLogin } from "@maersk-global/shared-js";
import { isUserLogged } from "./utilities";

/**
 * Route guard that redirects to login if there is no Forgerock JWT
 * @param param Used for composing the callback URL to go to after a successful login
 * @param nextAction The router next action, usually next()
 */
export default function redirectIfNotLogged(param, nextAction) {
  if (isUserLogged()) {
    nextAction();
  } else {
    redirectToLogin(`shipments/${param}`);
  }
}
